import { Box, BoxProps, forwardRef, LinkProps } from '@bonusly/design-system';

export const BoxLink = forwardRef<LinkProps, 'a'>((props, ref) => <Box as="a" ref={ref} {...(props as unknown as BoxProps)} />);
